export default "__VITE_ASSET__RRXMFQAf__"